export const JEWISHNESS_ON_DELETE_REQUESTED = 'JEWISHNESS_ON_DELETE_REQUESTED';
export const JEWISHNESS_ON_DELETE_SUCCEEDED = 'JEWISHNESS_ON_DELETE_SUCCEEDED';
export const JEWISHNESS_ON_DELETE_FAILED = 'JEWISHNESS_ON_DELETE_FAILED';

export const JEWISHNESS_ON_DELETE_FILE_REQUESTED = 'JEWISHNESS_ON_DELETE_FILE_REQUESTED';
export const JEWISHNESS_ON_DELETE_FILE_SUCCEEDED = 'JEWISHNESS_ON_DELETE_FILE_SUCCEEDED';
export const JEWISHNESS_ON_DELETE_FILE_FAILED = 'JEWISHNESS_ON_DELETE_FILE_FAILED';

export const JEWISHNESS_ON_GET_ALL_REQUESTED = 'JEWISHNESS_ON_GET_ALL_REQUESTED';
export const JEWISHNESS_ON_GET_ALL_SUCCEEDED = 'JEWISHNESS_ON_GET_ALL_SUCCEEDED';
export const JEWISHNESS_ON_GET_ALL_FAILED = 'JEWISHNESS_ON_GET_ALL_FAILED';

export const JEWISHNESS_ON_GET_FORM_REQUESTED = 'JEWISHNESS_ON_GET_FORM_REQUESTED';
export const JEWISHNESS_ON_GET_FORM_SUCCEEDED = 'JEWISHNESS_ON_GET_FORM_SUCCEEDED';
export const JEWISHNESS_ON_GET_FORM_FAILED = 'JEWISHNESS_ON_GET_FORM_FAILED';

export const JEWISHNESS_ON_GET_ONE_REQUESTED = 'JEWISHNESS_ON_GET_ONE_REQUESTED';
export const JEWISHNESS_ON_GET_ONE_SUCCEEDED = 'JEWISHNESS_ON_GET_ONE_SUCCEEDED';
export const JEWISHNESS_ON_GET_ONE_FAILED = 'JEWISHNESS_ON_GET_ONE_FAILED';

export const JEWISHNESS_ON_SAVE_REQUESTED = 'JEWISHNESS_ON_SAVE_REQUESTED';
export const JEWISHNESS_ON_SAVE_SUCCEEDED = 'JEWISHNESS_ON_SAVE_SUCCEEDED';
export const JEWISHNESS_ON_SAVE_FAILED = 'JEWISHNESS_ON_SAVE_FAILED';
